"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStoreLinkSchema = void 0;
const zod_1 = require("zod");
/**
 * CustomerStoreLink — junction row that binds a global Cognito identity (cognitoSub)
 * to a per-store profile (customerId) within one tenant (tenantId).
 *
 * DynamoDB table: agenticpos-pos-dynamodb-customer-stores-{stage}
 * PK: cognitoSub (S), SK: tenantId (S)
 *
 * One row per (customer, store) pair. A single-partition query on cognitoSub
 * returns all stores the customer belongs to (powers the account hub).
 */
exports.CustomerStoreLinkSchema = zod_1.z.object({
    cognitoSub: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    customerId: zod_1.z.string(),
    storeName: zod_1.z.string().optional(),
    joinedAt: zod_1.z.number(),
    welcomeEmailSentAt: zod_1.z.number().optional(),
});
//# sourceMappingURL=customer-store-link.schema.js.map